export const settings = (state = {settings: []}, action) => {

    if (action.type === "SETTINGS_LOADED") {
        return {...state, settings: action.settings};
    }

    return {...state};
};